import { makeStyles, Theme } from '@material-ui/core/styles';
import { grey } from '@material-ui/core/colors';

export const useStyles = makeStyles(
  (theme: Theme) => ({
    value: {
      fontSize: 34,
      marginBottom: theme.spacing(1),
    },
    yesValue: {
      fontSize: 20,
    },
    title: {
      flexGrow: 1,
      maxWidth: 280,
      //height: 60,
      fontSize: 16,
      marginBottom: theme.spacing(3),
      color: '#757575',
    },
    content: {
      flexGrow: 1,
      height: '100vh',
      overflow: 'auto',
    },
    container: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(4),
    },
    gridPaper: {
      padding: theme.spacing(1, 2, 2, 2),
      boxShadow: theme.shadows[0],
    },
    paper: {
      padding: theme.spacing(2),
      display: 'flex',
      overflow: 'auto',
      flexDirection: 'column',
    },
    fixedHeight: {
      height: 240,
    },
    logo: {
      margin: theme.spacing(2),
    },
    alert: {
      margin: '20px 0',
      padding: 20,
      backgroundColor: '#ffcc00',
      borderRadius: 10,
    },
    infoContainer: {
      display: 'flex',
      marginBottom: theme.spacing(1),
      //height: '20%',
    },
    link: {
      display: 'inline-block',
      textTransform: 'uppercase',
      color: theme.palette.info.main,
      letterSpacing: 0.4,
      fontSize: 14,
      //marginLeft: theme.spacing(1),
      //fontWeight: 600,
      margin: `0 ${theme.spacing(3)}px 0 0`,
    },
    disabledLink: {
      display: 'inline-block',
      textTransform: 'uppercase',
      color: grey[500],
      letterSpacing: 0.4,
      fontSize: 14,
      //marginLeft: theme.spacing(1),
      //fontWeight: 600,
      margin: `0 ${theme.spacing(3)}px 0 0`,
    },
  }),
  {
    index: 1,
  }
);
